// removed by extract-text-webpack-plugin
module.exports = {"headerBody":"_3hqM3 _38618 _2kZNz GjCgU _17S31 _3TD8R","headerTextInput":"_3RsBq _2hwsw _1FLRv _4GzCU _342no","subheader":"_2iZsI _38YTw _2AJrG","subheaderBody":"jgTY3 _17S31","subheaderLink":"_1usD6","headerSchema":"QplMQ _1EuOD _1MD7G"};


//////////////////
// WEBPACK FOOTER
// ./reference/components/ReferenceHeader.css
// module id = 1324
// module chunks = 3